import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Popup from '../../index';
import {tutorialPopup, videoPopup} from '../../../../../actions/popupActions';
import Icon from '../../../icon';
import Button from "../../../button";
import './index.css';

function TutorialPopup ({warning}) {

	const [isCopied, setIsCopied] = useState(false);
	const [video, setVideo] = useState({
		id: 'R9FCtRrytO8',
		preview: '/img/getting-started-1.jpg'
	});

	const { t } = useTranslation();
	const language = useSelector(state => state.languageReducer.language);
	const dispatch = useDispatch();

	useEffect(() => {
		if(warning){
			switch (language) {
				case 'fr' :
					setVideo({
						id: '1alh8Kj1gok',
						preview: '/img/getting-started-2-fr.jpg'
					});
					break;
				case 'es' :
					setVideo({
						id: '7CwacDt647Y',
						preview: '/img/getting-started-2-es.jpg'
					});
					break;
				default :
					setVideo({
						id: 'PnnotRIxkeQ',
						preview: '/img/getting-started-2.jpg'
					});
					break;
			}
		} else {
			switch (language) {
				case 'fr' :
					setVideo({
						id: '_6bjRYKjesg',
						preview: '/img/getting-started-1-fr.jpg'
					});
					break;
				case 'es' :
					setVideo({
						id: 'ciHtD1miW1I',
						preview: '/img/getting-started-1-es.jpg'
					});
					break;
				default :
					setVideo({
						id: 'R9FCtRrytO8',
						preview: '/img/getting-started-1.jpg'
					});
					break;
			}
		}
	}, [warning, language]);

	const handleClose = () => {
		dispatch(tutorialPopup(false));
		localStorage.setItem('isTutorialVideoViewed', true);
		if(warning){
			localStorage.setItem('isPendingInvitationTutorialVideoViewed', true);
		}
	};

	const handleVideoPopup = (e) => {
		e.preventDefault();
		dispatch(tutorialPopup(false));
		dispatch(videoPopup(video.id));
		localStorage.setItem('isTutorialVideoViewed', true);

		if(warning){
			localStorage.setItem('isPendingInvitationTutorialVideoViewed', true);
		}
	};

	const copyToClipboard = (textToCopy) => {
		// navigator clipboard api needs a secure context (https)
		if (navigator.clipboard && window.isSecureContext) {
			// navigator clipboard api method'
			return navigator.clipboard.writeText(textToCopy);
		} else {
			// text area method
			let textArea = document.createElement("textarea");
			textArea.value = textToCopy;
			// make the textarea out of viewport
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			return new Promise((res, rej) => {
				// here the magic happens
				document.execCommand('copy') ? res() : rej();
				textArea.remove();
			});
		}
	};

	const handleVideoSharing = () => {
		copyToClipboard('https://youtu.be/' + video.id)
			.then(() => {

				setIsCopied(true);

				setTimeout(() => {
					if(document.querySelector('.tutorial-popup__copied')){
						document.querySelector('.tutorial-popup__copied').classList.add('vanishing');
					}
				}, 100);
				setTimeout(() => {
					setIsCopied(false);
				}, 750)

			})
			.catch(() => console.log('error'));
	};

	return (
		<Popup className="tutorial-popup p-4" onClose={handleClose}>
			<h2>{t("textWelcomeToGSC")}</h2>
			<p className="mb-4">{t("tutorialPopupClickToWatch")}</p>
			<div className="text-center">
				<div className="tutorial-popup__video position-relative">
					<button className="tutorial-popup__playVideo" onClick={handleVideoPopup}>
						<Icon name="play-circle" />
						<img data-video={video.id} className="d-block" src={video.preview} width="300" alt=""/>
					</button>
					<button className="tutorial-popup__shareVideo" onClick={handleVideoSharing}>
						<Icon name="share-alt" className="mr-1" /> {t("VideoLink")}
					</button>
					{
						isCopied && <p className="tutorial-popup__copied"><em>{t("tutorialPopupCopied")}</em></p>
					}
				</div>
			</div>
			<div className="d-flex justify-content-center mt-4">
				<Button className="btn-primary" onClick={handleVideoPopup}>{t("watchTutorialText")}</Button>
				<Button className="btn-link font-weight-normal" onClick={handleClose}>{t("skipBtn")}</Button>
			</div>
		</Popup>
	)
}

export default TutorialPopup;
